import { Star } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

// Says, in words, whether a PERSON has picked this part's main photo — the default first photo never counts (his
// rule, 27 Oct). Sits under the photos on the part page and in Identify & Completion.
export function MainPhotoStatus({ picked, hasPhotos, testid }) {
  const { has } = useAuth();
  const can = has("archive_photos");
  if (picked) {
    return (
      <div data-testid={testid} data-state="picked" className="mt-3 inline-flex items-center gap-1.5 rounded-lg bg-emerald-50 border border-emerald-200 px-2.5 py-1.5 text-sm font-semibold text-emerald-800">
        <Star className="w-4 h-4 fill-current" />Main photo picked
      </div>
    );
  }
  const words = !hasPhotos ? "No photos yet — add one, then pick the main photo."
    : can ? "No main photo picked yet — tap ★ on the photo that stands for this part (or \"Set as main photo\" on the big photo)."
      : "No main photo picked yet — someone with the photo permission picks it.";
  return (
    <div data-testid={testid} data-state="not-picked" className="mt-3 flex items-start gap-1.5 rounded-lg bg-amber-50 border border-amber-300 px-2.5 py-1.5 text-sm font-semibold text-amber-900">
      <Star className="w-4 h-4 mt-0.5 shrink-0" /><span>{words} It's needed to finish the part.</span>
    </div>
  );
}
